import React, { Component } from 'react';
import PropTypes from 'prop-types';

const {
  i18n: {
    __,
  },
} = wp;

/**
 * Schedule component.
 */
class MiniSchedule extends Component {
  static propTypes = {
    listingUrl: PropTypes.string,
  };

  static defaultProps = {
    listingUrl: '',
  };

  static getMsSinceMidnight(fullDate) {
    const partDate = new Date(fullDate);
    return fullDate - partDate.setHours(0, 0, 0, 0);
  }

  state = {
    live: [],
    tonight: [],
    loading: true,
  };

  /**
   * Render the schedule on load.
   */
  componentDidMount() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    this.fetchData(timeZone);
  }

  fetchData(timeZone) {
    const { apiFetch } = wp;
    let tz = timeZone;
    if ('undefined' === typeof (timeZone)) {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    }
    const cacheBuster = Math.floor(Date.now() / (60 * 30 * 1000));
    apiFetch({
      path: `/nbc/v1/gracenote/${tz}?time=${cacheBuster}`,
    })
      .then((result) => {
        this.setState({
          live: result.live,
          tonight: result.tonight,
          loading: false,
        });
      });
  }

  render() {
    const {
      live,
      loading,
      tonight,
    } = this.state;
    if (loading) {
      const {
        cozi: {
          staticUrl,
        },
      } = window;

      return (
        <div id="loading">
          <img
            src={`${staticUrl}/images/cozi_preloader.png`}
            alt={__('Loading', 'cozi')}
          />
        </div>
      );
    }
    if (0 === live.length) {
      return '';
    }
    const { listingUrl } = this.props;
    const today = live[Object.keys(live)[0]];
    const entry = today.shift();
    const later = today.shift();
    const tvListings = __('TV Listings', 'cozi');
    const allTvListings = __('All TV Listings', 'cozi');
    const linkName = `&amp;lpos=${tvListings}&amp;lid=${allTvListings}`;
    return (
      <div className="module tvListingsModule box box-11">
        <div id="tv_listing_result">
          <div className="listingsContainer">
            <ul id="onNow">
              <li className="first">
                <h3>
                  {__('On Now', 'cozi')}
                  <span className="time">{entry.startPretty}</span>
                </h3>
                <img
                  src={entry.image}
                  alt={entry.title}
                />
                <div className="title">{entry.title}</div>
                <div className="summShowTitle">{entry.episodeTitle}</div>
              </li>
              {later && (
                <li className="onLater">
                  <h3>
                    {__('On Later', 'cozi')}
                    <span className="time">{later.startPretty}</span>
                  </h3>
                  <img
                    src={later.image}
                    alt={later.title}
                  />
                  <div className="title">{later.title}</div>
                  <div className="summShowTitle">{later.episodeTitle}</div>
                </li>
              )}
              {tonight && (
                <li className="last">
                  <h3>
                    {__('On Tonight', 'cozi')}
                    <span className="time">{tonight.startPretty}</span>
                  </h3>
                  <img
                    src={tonight.image}
                    alt={tonight.title}
                  />
                  <div className="title">{tonight.title}</div>
                  <div className="summShowTitle">{tonight.episodeTitle}</div>
                </li>
              )}
            </ul>
            <div className="listings" id="coziListings">
              <a
                href={listingUrl}
                name={linkName}
                data-lpos={tvListings}
                data-lid={allTvListings}
              >
                {__('See All TV Listings', 'cozi')}
                <i className="fa fa-angle-double-right" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MiniSchedule;
